RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    function getObjectName(objectType) {
        return (objectType === RivalIQ.enums.insightsObjectType.post ? 'posts' : 'frames');
    }

    function getReachGraphTitle(objectType) {
        const objectNameSingle = (objectType === RivalIQ.enums.insightsObjectType.post ? 'post' : 'frame');
        return ['Average', objectNameSingle].join(' ');
    }

    const MetricSummaryTooltip = RivalIQ.apps.Dashboard.widgets.MetricSummaryTooltip.extend({
        getTemplate: _.constant('#insightsSummaryTooltipWithContextTemplate'),

        serializeData: function () {
            const me = this;

            if (me.model || me.collection.length === 1) {
                me.metric = me.model || me.collection.first();
            }

            return {
                metric: me.metric,
                pctOfOverall: me.getOption('pctOfOverall'),
                objectName: getObjectName(me.metric.get('objectType')),
                showPctOfOverall: me.getOption('showPctOfOverall')
            };
        }
    });

    const Line = RivalIQ.apps.Dashboard.widgets.LineChart.extend({

        getChartAttributes: function () {
            const me = this;

            const baseChartAttributes = RivalIQ.apps.Dashboard.widgets.LineChart.prototype.getChartAttributes.call(me);
            return _.extend({
                minLeftMargin: 42
            }, baseChartAttributes);
        },

        loadData: function () {
            const me = this;

            if (!me.getProp('showPctOfOverall')) {
                return RivalIQ.apps.Dashboard.widgets.LineChart.prototype.loadData.call(me);
            }

            const pctOfOverallMetric = me.dashboardModel.metrics.at(0).build({
                property: 'pct_of_overall'
            });

            return $.when(pctOfOverallMetric.fetch(), RivalIQ.apps.Dashboard.widgets.LineChart.prototype.loadData.call(me))
                .then(function (pctOfOverall) {
                    me.pctOfOverall = pctOfOverall.getValue();
                });
        },

        getTooltip: function () {
            const me = this;

            return {
                title: function (data, index) {
                    const model = me.collection.first();
                    return model.getDomainName(index, {
                        expand: true
                    });
                },

                content: function (data) {
                    const viewOptions = {
                        collection: new RivalIQ.collections.MetricDefinitions(me.collection.map(function (metric, i) {
                            const value = data[0].value[i];

                            return new RivalIQ.models.MetricDefinition(_.extend(metric.toJSON(), {
                                value: metric.format(value)
                            }));
                        })),
                        showPctOfOverall: Boolean(me.getProp('showPctOfOverall'))
                    };

                    if (viewOptions.showPctOfOverall) {
                        viewOptions.pctOfOverall = _.last(me.pctOfOverall[data[0].x]);
                    }

                    return new MetricSummaryTooltip(viewOptions).render().el.outerHTML;
                }
            };
        }
    });

    const LineChartWidget = RivalIQ.apps.Dashboard.widgets.MetricLineChartWidget.extend({
        view: Line
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART, LineChartWidget);


    function getInstagramWidgetDefinitions(dashboardModel) {

        const metric = dashboardModel.metric;

        const objectType = dashboardModel.getProp('objectType');
        const objectName = getObjectName(objectType);

        let avgReachInHourMetric = 'avg_reach_in_period';
        let avgReachInDayMetric = 'avg_reach_in_period';
        let avgReachPerPeriodMetricName = 'Reach';
        let avgReachGraphTitle = `${getReachGraphTitle(objectType)} Reach`;

        if (objectType === RivalIQ.enums.insightsObjectType.post) {
            avgReachInHourMetric = avgReachInDayMetric = 'avg_organic_reach_in_period';
            avgReachPerPeriodMetricName = `${avgReachPerPeriodMetricName}, Organic`;
            avgReachGraphTitle = 'Average Post Reach, Organic';
        }

        let widgets = [
            {
                instanceId: 'count-hourly',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_activity_per_period',
                        dimensions: ['hour'],
                        className: 'your-time-usage',
                        name: `Average Daily ${objectName}`
                    })
                ]),
                props: {
                    ticks: 6,
                    title: `Average Daily ${objectName} per Published Hour`,
                    showPctOfOverall: true
                }
            },
            {
                instanceId: 'count-daily',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_activity_per_period',
                        dimensions: ['dayOfWeek'],
                        className: 'your-time-usage',
                        name: `Average Daily ${objectName}`
                    })
                ]),
                props: {
                    title: `Average Daily ${objectName} per Published Day`,
                    ticks: 7,
                    showPctOfOverall: true
                }
            },
            {
                instanceId: 'eng-rate-hourly',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: avgReachInHourMetric,
                        dimensions: ['hour'],
                        name: avgReachPerPeriodMetricName,
                        className: 'your-time-usage'
                    })
                ]),
                props: {
                    ticks: 6,
                    title: `${avgReachGraphTitle} per Published Hour`
                }
            },
            {
                instanceId: 'eng-rate-daily',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: avgReachInDayMetric,
                        dimensions: ['dayOfWeek'],
                        name: avgReachPerPeriodMetricName,
                        className: 'your-time-usage'
                    })
                ]),
                props: {
                    ticks: 7,
                    title: `${avgReachGraphTitle} per Published Day`
                }
            }
        ];

        if (dashboardModel.getProp('instanceIds')) {
            widgets = _.filter(widgets, function (def) {
                return _.includes(dashboardModel.getProp('instanceIds'), def.instanceId);
            });
        }

        return widgets;
    }

    function getLinkedInWidgetDefinitions(dashboardModel) {

        const metric = dashboardModel.metric;

        let widgets = [
            {
                instanceId: 'count-hourly',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_activity_per_period',
                        dimensions: ['hour'],
                        className: 'your-time-usage',
                        name: 'Average Daily Updates'
                    })
                ]),
                props: {
                    ticks: 6,
                    title: 'Average Daily Updates per Published Hour',
                    showPctOfOverall: true
                }
            },
            {
                instanceId: 'count-daily',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_activity_per_period',
                        dimensions: ['dayOfWeek'],
                        className: 'your-time-usage',
                        name: 'Average Daily Updates'
                    })
                ]),
                props: {
                    title: 'Average Daily Updates per Published Day',
                    ticks: 7,
                    showPctOfOverall: true
                }
            },
            {
                instanceId: 'eng-rate-hourly',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_impressions_in_period',
                        dimensions: ['hour'],
                        name: 'Average Update Impressions',
                        className: 'your-time-usage'
                    })
                ]),
                props: {
                    ticks: 6,
                    title: 'Average Update Impressions per Published Hour'
                }
            },
            {
                instanceId: 'eng-rate-daily',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_impressions_in_period',
                        dimensions: ['dayOfWeek'],
                        name: 'Average Update Impressions',
                        className: 'your-time-usage'
                    })
                ]),
                props: {
                    ticks: 7,
                    title: 'Average Update Impressions per Published Day'
                }
            }
        ];

        if (dashboardModel.getProp('instanceIds')) {
            widgets = _.filter(widgets, function (def) {
                return _.includes(dashboardModel.getProp('instanceIds'), def.instanceId);
            });
        }

        return widgets;
    }

    function getFacebookWidgetDefinitions(dashboardModel) {

        const metric = dashboardModel.metric;

        const objectType = dashboardModel.getProp('objectType');
        const objectName = getObjectName(objectType);

        let widgets = [
            {
                instanceId: 'count-hourly',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_activity_per_period',
                        dimensions: ['hour'],
                        className: 'your-time-usage',
                        name: `Average Daily ${objectName}`
                    })
                ]),
                props: {
                    ticks: 6,
                    title: `Average Daily ${objectName} per Published Hour`,
                    showPctOfOverall: true
                }
            },
            {
                instanceId: 'count-daily',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_activity_per_period',
                        dimensions: ['dayOfWeek'],
                        className: 'your-time-usage',
                        name: `Average Daily ${objectName}`
                    })
                ]),
                props: {
                    title: `Average Daily ${objectName} per Published Day`,
                    ticks: 7,
                    showPctOfOverall: true
                }
            },
            {
                instanceId: 'eng-rate-hourly',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_organic_reach_in_period',
                        dimensions: ['hour'],
                        name: 'Average Post Reach, Organic',
                        className: 'your-time-usage'
                    })
                ]),
                props: {
                    ticks: 6,
                    title: 'Average Post Reach, Organic per Published Hour'
                }
            },
            {
                instanceId: 'eng-rate-daily',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_organic_reach_in_period',
                        dimensions: ['dayOfWeek'],
                        name: 'Average Post Reach, Organic',
                        className: 'your-time-usage'
                    })
                ]),
                props: {
                    ticks: 7,
                    title: 'Average Post Reach, Organic per Published Day'
                }
            }
        ];

        if (dashboardModel.getProp('instanceIds')) {
            widgets = _.filter(widgets, function (def) {
                return _.includes(dashboardModel.getProp('instanceIds'), def.instanceId);
            });
        }

        return widgets;
    }

    function getTwitterWidgetDefinitions(dashboardModel) {

        const metric = dashboardModel.metric;

        let widgets = [
            {
                instanceId: 'count-hourly',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_activity_per_period',
                        dimensions: ['hour'],
                        className: 'your-time-usage',
                        name: 'Average Daily Tweets'
                    })
                ]),
                props: {
                    ticks: 6,
                    title: 'Average Daily Tweets per Published Hour',
                    showPctOfOverall: true
                }
            },
            {
                instanceId: 'count-daily',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_activity_per_period',
                        dimensions: ['dayOfWeek'],
                        className: 'your-time-usage',
                        name: 'Average Daily Tweets'
                    })
                ]),
                props: {
                    title: 'Average Daily Tweets per Published Day',
                    ticks: 7,
                    showPctOfOverall: true
                }
            },
            {
                instanceId: 'impressions-hourly',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_impressions_in_period',
                        dimensions: ['hour'],
                        name: 'Average Tweet Impressions',
                        className: 'your-time-usage'
                    })
                ]),
                props: {
                    ticks: 6,
                    title: 'Average Tweet Impressions per Published Hour'
                }
            },
            {
                instanceId: 'impressions-daily',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE_LINE_CHART,
                metrics: new RivalIQ.collections.MetricDefinitions([
                    metric.build({
                        property: 'avg_impressions_in_period',
                        dimensions: ['dayOfWeek'],
                        name: 'Average Tweet Impressions',
                        className: 'your-time-usage'
                    })
                ]),
                props: {
                    ticks: 7,
                    title: 'Average Tweet Impressions per Published Day'
                }
            }
        ];

        if (dashboardModel.getProp('instanceIds')) {
            widgets = _.filter(widgets, function (def) {
                return _.includes(dashboardModel.getProp('instanceIds'), def.instanceId);
            });
        }

        return widgets;
    }

    const InsightsTimeWidget = RivalIQ.apps.SocialPosts.widgets.TimeWidget.extend({

        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,
        scheduledExportAdvancedSettingsEnabled: false,

        title: function () {
            const me = this;

            if (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) {
                return 'Post Time';
            } else {
                return 'Publish Time';
            }
        },

        description: function () {
            const me = this;

            if (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) {
                switch (me.getProp('source')) {
                    case RivalIQ.enums.sources.INSTAGRAM_INSIGHTS:
                        return RivalIQ.strings.instagram_insights_posts_time_usage_description;

                    case RivalIQ.enums.sources.LINKEDIN:
                        return RivalIQ.strings.linked_in_insights_posts_time_usage_description;

                    case RivalIQ.enums.sources.FACEBOOK_INSIGHTS:
                        return RivalIQ.strings.facebook_insights_posts_time_usage_description;

                    case RivalIQ.enums.sources.TWITTER_INSIGHTS:
                        return RivalIQ.strings.twitter_insights_posts_time_usage_description;

                    default:
                        throw new Error(`Insights Time Widget - unknown source ${me.getProp('source')}`);
                }

            } else {
                return RivalIQ.strings.instagram_insights_stories_time_usage_description;
            }
        },

        panelView: RivalIQ.apps.Dashboard.views.Panel,

        filter: function () {
            const me = this;

            const objectType = me.getProp('objectType');
            const isPostObjectType = (objectType === RivalIQ.enums.insightsObjectType.post);

            return (isPostObjectType && RivalIQ.apps.Insights.utils.isLoadingInstagramPromotedPosts(me));
        },

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                hideLegend: true
            });

            if (props.objectType !== RivalIQ.enums.insightsObjectType.post) {
                props.objectType = RivalIQ.enums.insightsObjectType.story;
            }

            if (!me.metric) {
                me.metric = new RivalIQ.models.MetricDefinition(App.utils.createInsightsMetric(props.objectType, _.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId']
                }, props)));
            }
            _.extend(me.metric.attributes, props);

            return props;
        },

        widgetDefinitions: function () {
            const me = this;

            const metric = new RivalIQ.models.MetricDefinition(me.metric);

            switch (me.getProp('channel')) {
                case RivalIQ.enums.channels.INSTAGRAM:
                    return getInstagramWidgetDefinitions(me, metric);

                case RivalIQ.enums.channels.LINKEDIN:
                    return getLinkedInWidgetDefinitions(me, metric);

                case RivalIQ.enums.channels.FACEBOOK:
                    return getFacebookWidgetDefinitions(me, metric);

                case RivalIQ.enums.channels.TWITTER:
                    return getTwitterWidgetDefinitions(me, metric);

                default:
                    throw new Error(`unknown channel ${me.getProp('channel')}`);
            }
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_TIME_USAGE, InsightsTimeWidget);
});
